<template>
  <div class="vehicleProperty">
    <filter-search
      @search="search"
      exportTemplate="BoardCar"
      filename="车辆资产"
    />
    <!-- 车辆资产提示语 -->
    <el-alert type="info" :closable="false" :show-icon="false">
      <template slot="title">
        <span style="color: #236aea;" >注意：车辆资产看板中，不展示当前已经禁用的车型的相关数据。</span>
      </template>
    </el-alert>
    <!-- 全部 -->
    <all-vehicle-table :searchDate="searchDate" :tableData="allCarTableData" />
    <!-- 可发 -->
    <can-sent-table :searchDate="searchDate" :tableData="sentTableData" />
    <!-- 不可发 -->
    <cannot-sent-table :searchDate="searchDate" :tableData="notSentTableData" />
  </div>
</template>
<script>
import FilterSearch from '../FilterSearch.vue'
import AllVehicleTable from './allVehicleTable/index.vue'
import CanSentTable from './CanSentTable/index.vue'
import CannotSentTable from './CannotSentTable/index.vue'
import { postStatCar, postStatStandard } from '@/api/domain/workbench'

export default {
  components: {
    FilterSearch,
    AllVehicleTable,
    CanSentTable,
    CannotSentTable,
  },
  data() {
    return {
      searchDate: '',
      allCarTableData: [], // 全部车辆
      sentTableData: {}, // 可租
      notSentTableData: {}, // 不可租
    }
  },
  methods: {
    search(val, cb) {
      this.searchDate = val.searchDate
      Promise.all([this.postStatCar(), this.postStatStandard()])
        .finally(() => {
          cb()
        })
    },
    // 获取全部车辆数据
    async postStatCar() {
      const { data } = await postStatCar({ searchDate: this.searchDate })
      this.allCarTableData = data
      return data
    },
    // 获取可租不可租数据 type 1:可租，2:不可租
    async postStatStandard(type) {
      const params = {
        searchDate: this.searchDate,
        rentable: type,
      }
      const { data } = await postStatStandard(params)
      if (data) {
        this.sentTableData = data.statRentStandardVO || {}
        this.notSentTableData = data.statNonRentStandardVO || {}
      } else {
        this.sentTableData = {}
        this.notSentTableData = {}
      }

      return data
    },
  },
}
</script>
<style scoped lang="scss">
.vehicleProperty {
  ::v-deep .basic-list .basic-list__main .el-table__row .el-table__cell {
    padding-left: 0px;
  }
}
</style>
